import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';

// TriggerConfig routing
const TriggerConfig = Loadable(lazy(() => import('./TriggerConfig')));
const ChartConfig = Loadable(lazy(() => import('./chart-config/ChartConfig')));
const VisualReportScreenConfig = Loadable(lazy(() => import('./visual-report-screen-config/VisualReportScreenConfig')));

// ==============================|| MAIN ROUTING ||============================== //

const TroggerRoutes = {
    path: 'trigger',
    children: [
        {
            path: 'config',
            element: <TriggerConfig />
        },
        {
            path: 'chart-config',
            element: <ChartConfig />
        },
        {
            path: 'visual-report-config',
            element: <VisualReportScreenConfig />
        }
    ]
};

export default TroggerRoutes;
